module.exports = __webpack_public_path__ + "static/media/image3.f4c8796c.jpg";